<template>
  <div class="wifi-click-control-container">
    <el-card class="container-card" shadow="hover">
      <el-form :inline="true" :model="searchForm" label-position="right" label-width="80px" class="search-form"
        style="display: flex; align-items: center; flex-wrap: nowrap; gap: 10px; overflow-x: auto;">

        <el-form-item label="客户标识" size="small" style="display: flex;align-items: center;">
          <el-input v-model="searchForm.kehu" placeholder="请输入客户标识" clearable style="width: 200px;"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch" plain>搜索</el-button>
        </el-form-item>

        <el-form-item>
          <el-button size="small" icon="el-icon-refresh" @click="resetSearch" plain>重置</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="small" @click="handleAdd">新增</el-button>
        </el-form-item>

   
        <el-form-item>
          <el-button type="warning" size="small" @click="batchUpdate" :disabled="selection.length === 0">
            批量修改({{selection.length}})
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="success" size="small" @click="exportExcel" :disabled="selection.length === 0">
            导出选中项
          </el-button>
        </el-form-item>
      </el-form>

     
      <el-table 
        ref="multipleTable"
        :data="tableData" 
        border 
        stripe 
        style="width: 100%" 
        v-loading="loading"
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading" 
        element-loading-background="rgba(255, 255, 255, 0.7)"
        class="data-table"
        @selection-change="handleSelectionChange">
        
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        
        <el-table-column prop="id" label="ID" width="80" align="center" header-align="center"></el-table-column>
        <el-table-column prop="kehu" label="客户标识" width="220" align="center" header-align="center"></el-table-column>
        
        <el-table-column prop="upgl" label="设置概率(%)" width="200" align="center" header-align="center">
          <template slot-scope="scope">
            <el-input-number 
              v-model="scope.row.upgl" 
              :min="0" 
              :max="100" 
              size="mini"
              @change="handleProbabilityChange(scope.row)">
            </el-input-number>
          </template>
        </el-table-column>
        
        <el-table-column prop="reportedCount" label="已上报数" width="180" align="center" header-align="center"></el-table-column>
        <el-table-column prop="totalCount" label="总数" width="180" align="center" header-align="center"></el-table-column>
        <el-table-column prop="reportRate" label="上报率" width="180" align="center" header-align="center"></el-table-column>

        <el-table-column prop="uptype" label="上报行为" width="180" align="center" header-align="center">
          <template slot-scope="scope">
            <el-select v-model="scope.row.uptype" @change="handleTypeChange(scope.row)" size="mini">
              <el-option label="关键行为" value="6"></el-option>
              <el-option label="首唤" value="15"></el-option>
            </el-select>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="400" align="center" header-align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)" plain>编辑</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)" plain>删除</el-button>
            <el-button size="mini" type="primary" plain @click="generateHandle(scope.row)">生成点击链接</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination 
          @size-change="handleSizeChange" 
          @current-change="handleCurrentChange"
          :current-page="pagination.current" 
          :page-sizes="[10, 20, 50, 100]" 
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper" 
          :total="pagination.total" 
          background small>
        </el-pagination>
      </div>

      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%" @close="handleDialogClose">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
          <el-form-item label="客户标识" prop="kehu">
            <el-input v-model="form.kehu" placeholder="请输入客户标识" :disabled="isEditMode"></el-input>
          </el-form-item>
          <el-form-item label="设置概率(%)" prop="upgl">
            <el-input v-model="form.upgl" placeholder="请输入设置概率(%)"></el-input>
          </el-form-item>
          <el-form-item label="上报行为" prop="upgl">
            <el-select v-model="form.uptype" placeholder="请选择上报行为">
              <el-option label="关键行为" :value="'6'"></el-option>
              <el-option label="首唤" :value="'15'"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="handleSubmit" size="small">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="批量修改设置" :visible.sync="batchDialogVisible" width="30%">
        <el-form label-width="100px">
          <el-form-item label="上报概率(%)">
            <el-input-number v-model="batchForm.upgl" :min="0" :max="100"></el-input-number>
          </el-form-item>
          <el-form-item label="上报行为">
            <el-select v-model="batchForm.uptype">
              <el-option label="关键行为" value="6"></el-option>
              <el-option label="首唤" value="15"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="batchDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmBatchUpdate">确认</el-button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="generateDialog" width="700px">
        <el-form :model="form2">
          <el-form-item>
            <div style="width: 100%;">
              <el-input v-model="form2.url" placeholder="请输入生成的链接" clearable
                style="width: 80%; display: inline-block; vertical-align: middle;" />
              <el-button type="primary" @click="fuzhicopy"
                style="display: inline-block; vertical-align: middle; margin-left: 10px;">
                复制
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { get, post } from '../../until/controlRequest'
import { exportJsonToExcel } from '../../until/export2Excel'

export default {
  name: 'WifiClickControl',
  data() {
    return {
      generateDialog: false,
      form2: {},
      searchForm: {
        kehu: ''
      },
      tableData: [],
      loading: false,
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增控制信息',
      form: {
        id: null,
        kehu: '',
        upgl: '',
        uptype: '6'
      },
      rules: {
        kehu: [
          { required: true, message: '请输入客户标识', trigger: 'blur' }
        ],
        upgl: [
          { required: true, message: '请输入设置概率(%)', trigger: 'blur' }
        ]
      },
      isEditMode: false,
      
      selection: [], 
      batchDialogVisible: false,
      batchForm: { 
        upgl: 50,
        uptype: '6'
      },
      clickLinks: {} 
    }
  },
  created() {
    this.fetchPage()
  },
  methods: {

    handleSelectionChange(val) {
      this.selection = val
    },
    
    batchUpdate() {
      if (this.selection.length === 0) {
        this.$message.warning('请至少选择一条记录')
        return
      }
      this.batchDialogVisible = true
    },
    
    confirmBatchUpdate() {
      const params = this.selection.map(item => ({
        id: item.id,
        kehu: item.kehu,
        upgl: this.batchForm.upgl,
        uptype: this.batchForm.uptype
      }))
      
      post('/wifiClick/control/updateBatch', params)
        .then(() => {
          this.$message.success('批量修改成功')
          this.fetchPage()
          this.batchDialogVisible = false
        })
        .catch(() => {
          this.$message.error('批量修改失败')
        })
    },
    
    // 新增方法 - 导出Excel
    exportExcel() {
      if (this.selection.length === 0) {
        this.$message.warning('请至少选择一条记录')
        return
      }
      
      const tHeader = ['ID', '客户标识', '设置概率(%)', '已上报数', '总数', '上报率', '上报行为', '点击链接']
      const filterVal = ['id', 'kehu', 'upgl', 'reportedCount', 'totalCount', 'reportRate', 'uptype', 'clickLink']
      
      const data = this.selection.map(item => {
        return {
          ...item,
          uptype: item.uptype === '6' ? '关键行为' : '首唤',
          clickLink: this.clickLinks[item.id] || '未生成链接'
        }
      })
      
      exportJsonToExcel({
        header: tHeader,
        data,
        key: filterVal,
        filename: 'WIFI点击控制数据_' + new Date().toLocaleDateString()
      })
    },
    
 
    generateHandle(row) {
      this.$message.success('生成成功')
      this.generateDialog = true
      const url = `https://control.zjwec.cn/api/wifi/report?aid=__AID__&cid=__CID__&cgid=__CGID__&uid=__UID__&pid=__PID__&sid=__SID__&stime=__STIME__&os=__OS__&idfa=__IDFA__&mac=__MAC__&imei=__IMEI__&oaid=__OAID__&androidid=__ANDROID_ID__&hashoaid=__HASH_OAID__&plainidfa=__PLAIN_IFDA__&plainmac=__PLAIN_MAC__&plainimei=__PLAIN_IMEI__&ip=__IP__&ua=__UA__&callbackurl=__CALLBACK_URL__&caid=__CAID__&caidversion=__CAID_VERSION__&lastcaid=__LAST_CAID__&lastcaidversion=__LAST_CAID_VERSION__&osversion=__OS_VERSION__&model=__MODEL__&kehu=${row.kehu}`
      this.form2.url = url
      this.$set(this.clickLinks, row.id, url)
    },
    
    handleProbabilityChange(row) {
      post('/wifiClick/control/update', {
        id: row.id,
        kehu: row.kehu,
        upgl: row.upgl,
        uptype: row.uptype
      }).then(() => {
        this.$message.success('概率更新成功')
      })
    },
    
    handleTypeChange(row) {
      post('/wifiClick/control/update', {
        id: row.id,
        kehu: row.kehu,
        upgl: row.upgl,
        uptype: row.uptype
      }).then(() => {
        this.$message.success('行为类型更新成功')
      })
    },
    

    async fuzhicopy() {
      try {
        await navigator.clipboard.writeText(this.form2.url);
        this.$message.success('复制成功');
      } catch (err) {
        console.error('复制失败', err);
        this.$message.error('复制失败，请手动复制');
      }
    },
    fetchPage() {
      this.loading = true
      const params = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.size,
        kehu: this.searchForm.kehu
      }

      get('/wifiClick/control/list', params)
        .then(data => {
          this.tableData = data.records || []
          this.pagination.total = data.total || 0
        })
        .catch(() => {
          this.tableData = []
          this.pagination.total = 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSearch() {
      this.pagination.current = 1
      this.fetchPage()
    },
    resetSearch() {
      this.searchForm = {
        kehu: ''
      }
      this.handleSearch()
    },
    handleAdd() {
      this.dialogTitle = '新增控制信息'
      this.form = {
        id: null,
        kehu: '',
        upgl: '',
        uptype: '6'
      }
      this.isEditMode = false
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleEdit(row) {
      this.dialogTitle = '编辑控制信息'
      this.form = {
        id: row.id,
        kehu: row.kehu,
        upgl: row.upgl,
        uptype: row.uptype,
      }
      this.isEditMode = true
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return

        const api = this.form.id ? '/wifiClick/control/update' : '/wifiClick/control/save'
        post(api, this.form)
          .then(() => {
            this.$message.success(this.form.id ? '更新成功' : '新增成功')
            this.dialogVisible = false
            this.fetchPage()
          })
          .catch(() => {
            this.$message.error(this.form.id ? '更新失败' : '新增失败')
          })
      })
    },
    handleDelete(row) {
      this.$confirm(`确定要删除客户标识为 "${row.kehu}" 的控制信息吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        post(`/wifiClick/control/delete/${row.id}`)
          .then(() => {
            this.$message.success('删除成功')
            this.fetchPage()
          })
          .catch(() => {
            this.$message.error('删除失败')
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    handleDialogClose() {
      this.$refs.form && this.$refs.form.resetFields()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.fetchPage()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.fetchPage()
    }
  }
}
</script>

<style scoped>
.wifi-click-control-container {
  padding: 20px;
}

.container-card {
  min-height: calc(100vh - 90px);
}

.search-form {
  margin-bottom: 20px;
}

.data-table {
  margin-bottom: 20px;
}

.pagination-container {
  text-align: center;
  margin-top: 20px;
}

.el-button--warning {
  margin-left: 10px;
}

.el-button--success {
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/wifi/wifiClickControl.vue